export default __webpack_public_path__ + "static/nude5-5129c23ef513bbe85b467a6d008a8a52.jpg";